export default __webpack_public_path__ + "static/media/bidet.af6b18a1.png";